var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../../../components/UnlinkedApplicationForm";
import { AutoEntity, saveAutoEntity, } from "../../../../../features/unlinked-application/unlinkedApplicationSlice";
import { Autocomplete, Button } from "@savvyinsure/react-ui";
import { completedPage, selectedVehicleInformation, } from "../../../../../lib/Avo";
import { useHistory, useParams } from "react-router-dom";
import AppBody from "../../../../../components/AppBody";
import Header from "../../../../../components/Header";
import { PHASE } from "../../../../../routeConfig";
import { QueryLoader } from "../../../../../components/QueryLoader";
import { ToggleButtonGroup } from "../../../../../components/ToggleButton";
import VehicleBreadcrumbs from "../../../../../features/unlinked-application/components/VehicleBreadcrumbs";
import { skipToken } from "@reduxjs/toolkit/query";
import { transformVehicleInfoToSelectOption } from "../../../../../features/unlinked-application/utils";
import useAppDispatch from "../../../../../hooks/useAppDispatch";
import useAppSelector from "../../../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import { useGetVehicleMakesQuery } from "../../../../../services/savvy";
var HEADER_TITLE = "Select vehicle make";
var TYPE_OF_ENTITY = AutoEntity.Vehicle;
export default function UnlinkedApplicationAutoVehicleEditMake() {
    var _a, _b, _c, _d;
    var makeRef = React.useRef(null);
    var dispatch = useAppDispatch();
    var push = useHistory().push;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var vehicleId = useParams().vehicleId;
    var vehicleToEdit = useAppSelector(function (state) {
        var vehicles = state.unlinkedApplication.auto.vehicles;
        return vehicles.find(function (_a) {
            var id = _a.id;
            return id === vehicleId;
        });
    });
    var makesQuery = useGetVehicleMakesQuery((_b = (_a = vehicleToEdit === null || vehicleToEdit === void 0 ? void 0 : vehicleToEdit.year) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : skipToken);
    var _e = useForm({
        defaultValues: {
            make: (vehicleToEdit === null || vehicleToEdit === void 0 ? void 0 : vehicleToEdit.make)
                ? transformVehicleInfoToSelectOption(vehicleToEdit.make)
                : undefined,
        },
    }), handleSubmit = _e.handleSubmit, register = _e.register, watch = _e.watch, setValue = _e.setValue, isValid = _e.formState.isValid;
    var makeValue = watch("make");
    var makeOptions = (_d = (_c = makesQuery.data) === null || _c === void 0 ? void 0 : _c.map(transformVehicleInfoToSelectOption)) !== null && _d !== void 0 ? _d : [];
    var isLoading = makesQuery.isLoading;
    var onSubmit = handleSubmit(function (data) {
        var _a, _b;
        if (typeof vehicleId !== "string") {
            throw new Error("Error while saving vehicle make: Missing vehicle id");
        }
        var make = (_a = makesQuery.data) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
            var _b;
            var id = _a.id;
            return id === ((_b = data.make) === null || _b === void 0 ? void 0 : _b.value);
        });
        var isModified = ((_b = vehicleToEdit === null || vehicleToEdit === void 0 ? void 0 : vehicleToEdit.make) === null || _b === void 0 ? void 0 : _b.id) !== (make === null || make === void 0 ? void 0 : make.id);
        dispatch(saveAutoEntity({
            entity: TYPE_OF_ENTITY,
            data: __assign({ id: vehicleId, make: make }, (isModified && { model: undefined })),
        }));
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { optionSelected: data.make.value, selectedOption: data.make.value }));
        push(PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_MODEL.replace(":vehicleId", vehicleId));
    });
    var handleMakeSelect = React.useCallback(function (make) {
        selectedVehicleInformation(__assign(__assign({}, commonAnalyticsProperties), { vehicleDataType: "make", vehicleDataValue: make.value }));
        setValue("make", make, { shouldValidate: true });
        setTimeout(function () { return onSubmit(); });
    }, [setValue, onSubmit]);
    var handleToggleChange = React.useCallback(function (selected) {
        var _a;
        var make = (_a = makesQuery.data) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
            var id = _a.id;
            return id === selected;
        });
        if (make) {
            handleMakeSelect(transformVehicleInfoToSelectOption(make));
        }
    }, [handleMakeSelect, makesQuery.data]);
    React.useEffect(function () {
        register("make", { required: true });
    }, [register]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, { as: "form", action: "#", onSubmit: onSubmit },
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, { className: "pt-6" },
                React.createElement(VehicleBreadcrumbs, { vehicle: vehicleToEdit }),
                React.createElement(UnlinkedApplicationForm.Header, { className: "mb-4" }, HEADER_TITLE),
                React.createElement(QueryLoader, __assign({}, makesQuery),
                    React.createElement(Autocomplete, { id: "make", label: "Make", placeholder: "Select Make", value: makeValue, onChange: handleMakeSelect, options: makeOptions, ref: makeRef }),
                    React.createElement("div", { className: "my-4" },
                        React.createElement(ToggleButtonGroup, { variant: "grid", columns: 2, id: "make", options: makeOptions, value: makeValue === null || makeValue === void 0 ? void 0 : makeValue.value, onChange: handleToggleChange })))),
            React.createElement("div", { className: "bg-white p-4" },
                React.createElement(Button, { disabled: !isValid || isLoading }, "Continue")))));
}
